import { curry } from 'lib/util'
import { show } from 'app/_shared/events/notification/alert'

/**
 * Opens a specific notification
 *
 * @param {Function} callback                 callback to execute
 * @param {Gaia.AppModule.Spec} module        module composition
 * @param {Gaia.Component.Spec} component     action component
 * @param {Gaia.AppModule.EventHandler} event triggered event
 * @returns {Promise<void>}
 * @private
 */
const _show = async (callback, module, component, event) => {
  const { key, item } = event?.detail || event || {}

  await show(module, component, { key, item }, callback, event)
}

export default curry(_show)
